export enum Bundle {
    Small = 10,
    Medium = 20,
    Large = 30,
    One = 40
}

